//TODO remove this file as it's duplicated => To be replace with useFeature.tsx
export const schoolAdminSsoConfiguration = false;

export default {
  eventTicketInformation: true,
  showInstallPrompt: false,
};
